<template>
  <div id="dashboard-container" v-if="combinedData != null">
    <Banner />
    <Instructions v-if="global.accountType === 'sewist'"/>
    <div class="dashboard-content">
      <div class="stat-cards">
        <StatsCard :title="'Outstanding PPE to be Delivered (est.)'" :type="'outstanding'" />
        <StatsCard
          :title="'Total PPE Delivered (est.)'"
          :type="'delivered'"
          :className="'green-card'"
        />
      </div>

      <CategoryTabs
        v-if="combinedData"
        :sortedData="combinedData.data"
        :categories="combinedData.categories"
        :initialCategory="combinedData.categories[0]"
        :accountType="global.accountType"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Banner from "@/components/global/Banner";
import Instructions from "@/components/global/Instructions";
import StatsCard from "@/components/global/StatsCard";
import CategoryTabs from "@/components/global/CategoryTabs";
import { statusConstants } from "@/data/statusConstants";
export default {
  name: "Dashboard",
  components: {
    Banner,
    Instructions,
    StatsCard,
    CategoryTabs
  },

  computed: {
    ...mapState(["global"])
  },
  data() {
    return {
      combinedData: null
    };
  },
  mounted() {
    this.sortAndSetDashboardData(this.global.userData);
    this.$store.watch(
      state => state.global.userData,
      (newVal, oldVal) => {
        if (newVal) {
          this.sortAndSetDashboardData(newVal);
        }
      }
    );
  },
  methods: {
    sortAndSetDashboardData(userData) {
      if (!userData || !userData.sortedRequests) return;
      let combinedData = {};
      combinedData.data = userData.sortedRequests;
      if (this.global.accountType == "admin") {
        combinedData.categories = statusConstants().visibleAdminCategories;
      } else if (this.global.accountType == "sewist") {
        combinedData.categories = statusConstants().visibleSewistCategories;
      } else {
        this.error = true;
      }
      if (!combinedData.categories) return;
      this.combinedData = combinedData;
    }
  }
};
</script>

<style lang="scss" scoped>
#dashboard-container {
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background: linear-gradient(to right, rgb(32, 53, 109), rgb(216, 60, 180));
  .stat-cards {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    padding-right: 25px;
    @media (max-width: $sm) {
      display: block;
      width: 80%;
    }
  }
  .dashboard-content {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background: #ffffff;
  }
}
</style>
<style lang="scss">
.green-card {
  .item,
  .primary-stat {
    color: #2ec693 !important;
  }
}
</style>
